var pageIntroList = require("../../data/texts/PageIntro.json");

var HomeText = pageIntroList["Home"];

var AboutText = pageIntroList["About"];

var TeamText = pageIntroList["Team"];

var EventsText = pageIntroList["Events"];

var FAQText = pageIntroList["FAQ"];

export { HomeText, AboutText, TeamText, EventsText, FAQText };
